import { render, staticRenderFns } from "./EmergencyContactsSlot.vue?vue&type=template&id=a489e9b6&scoped=true"
import script from "./EmergencyContactsSlot.vue?vue&type=script&lang=js"
export * from "./EmergencyContactsSlot.vue?vue&type=script&lang=js"
import style0 from "./EmergencyContactsSlot.vue?vue&type=style&index=0&id=a489e9b6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a489e9b6",
  null
  
)

export default component.exports